import { LocalDateTime } from "@js-joda/core"
import { Policy } from "@shared/platform-api/generated"

export const sortByDescendingExpiry = (policies: ReadonlyArray<Policy>) => {
  const toLocalDateTime = (expiryTime: string) => LocalDateTime.parse(expiryTime)
  const sortedPolicies = [...policies]
  sortedPolicies
    .sort((a, b) => {
      const timeA = toLocalDateTime(a.expiryTime)
      const timeB = toLocalDateTime(b.expiryTime)
      return timeA.compareTo(timeB)
    })
    .reverse()
  return sortedPolicies
}
